<template>
  <div>
    <el-input v-model="data" type="textarea" v-bind="props"> </el-input>
  </div>
</template>
<style></style>
<script>
import { isObject } from "util";
export default {
  data() {
    return {
      data: ""
    };
  },
  props: {
    json: [Object, Array],
    jsonKey: {
      type: String,
      default: ""
    },
    fontSize: {
      type: Number,
      default: 18
    },
    props: {
      type: Object
    }
  },
  beforeMount() {
    if (this.json) {
      this.data = JSON.stringify(this.json);
    }
  },
  watch: {
    data: function(val) {
      if (val.length == 0) {
        this.$emit("change", null);
      } else if (Array.isArray(val) === true || isObject(val) === true) {
        this.$emit("change", JSON.parse(val));
      }
    }
  },
  methods: {}
};
</script>
